import { Text as ChakraText, TextProps } from '@chakra-ui/react';
import { forwardRef, Ref } from 'react';

type Props = Omit<TextProps, '__css' | 'sx' | 'fontSize' | 'fontWeight'>;

export const Text = forwardRef((props: Props, ref: Ref<HTMLParagraphElement>) => {
  return <ChakraText ref={ref} {...props} />;
});
